import {BaseContainerModel} from '../base-container.model';
import {bl_pgw_label_link_RowClass} from '../../dbschema';

export class PgwLabelLinkContainerModel extends BaseContainerModel {
  bl_pgw_label_link: bl_pgw_label_link_RowClass = new bl_pgw_label_link_RowClass();
}
